import { RENEW_TOKEN } from '../containers/Login/gql';
import { useMutation } from '@apollo/client';

export const useRenewToken = () => {
  const [renewToken, { loading }] = useMutation(RENEW_TOKEN);
  return { renewToken, loading };
};
